const VALID_IMAGE_TYPES = ['image/jpeg', 'image/png'];
const MAX_IMAGE_SIZE_MB = 5;
const MIN_IMAGE_WIDTH = 500;
const MIN_IMAGE_HEIGHT = 500;

const formatFileSize = (size: number) => {
  const sizeInMb = size / (1024 * 1024);
  if (sizeInMb >= 1) {
    return `${sizeInMb.toFixed(2)} МБ`;
  }

  const sizeInKb = size / 1024;
  return `${Math.max(1, Math.round(sizeInKb))} КБ`;
};

const getFileFormatLabel = (file: File) => {
  if (file.type === 'image/jpeg') {
    return 'JPG';
  }

  if (file.type === 'image/png') {
    return 'PNG';
  }

  const ext = file.name.split('.').pop()?.trim();
  return ext ? ext.toUpperCase() : 'неизвестный';
};

export const validateImageFile = async (file: File) => {
  if (!VALID_IMAGE_TYPES.includes(file.type)) {
    return `Файл "${file.name}" не поддерживается. Текущий формат: ${getFileFormatLabel(file)}. Разрешены только JPG и PNG.`;
  }

  if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
    return `Файл "${file.name}" слишком большой: ${formatFileSize(file.size)}. Максимальный размер — ${MAX_IMAGE_SIZE_MB} МБ.`;
  }

  return new Promise<string | null>((resolve) => {
    const img = new Image();
    const imageUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(imageUrl);

      if (img.width < MIN_IMAGE_WIDTH || img.height < MIN_IMAGE_HEIGHT) {
        resolve(
          `Файл "${file.name}" слишком маленький: ${img.width}x${img.height} px. Минимальное разрешение — ${MIN_IMAGE_WIDTH}x${MIN_IMAGE_HEIGHT} px.`,
        );
        return;
      }

      resolve(null);
    };

    img.onerror = () => {
      URL.revokeObjectURL(imageUrl);
      resolve(`Не удалось прочитать файл "${file.name}". Возможно, изображение повреждено или имеет неподдерживаемую структуру.`);
    };

    img.src = imageUrl;
  });
};
